module.exports = __webpack_public_path__ + "img/logo-old.8ead234f.png";